module.exports = __webpack_public_path__ + "static/media/dice-three.2d8ab18a.svg";